module.exports = __webpack_public_path__ + "static/media/edit-icon.fce0b3d9.svg";